import { render, staticRenderFns } from "./DettaglioDocumento.vue?vue&type=template&id=4f6c07df&"
import script from "./DettaglioDocumento.vue?vue&type=script&lang=js&"
export * from "./DettaglioDocumento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports